const config = {
	api: 'https://api-assistente.appcivico.com/api',
	appId: '2530803417016657',
};

if (window.location.host.indexOf('marina') !== -1) {
	config.api = 'https://api-marina.mandatoaberto.com.br/api';
	config.appId = '130305700981173';
}

module.exports = config;



// WEBPACK FOOTER //
// ./_source/javascripts/config/production.js